// @mui
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Stack,
  Typography,
} from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Iconify from '../../components/Iconify';
import {fKrDateKST} from '../../utils/formatTime';

// ----------------------------------------------------------------------


export default function CrewRejectHistoryDialog({ isOpen, closeDialog, history, editJobPost=null }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} maxWidth="sm" fullWidth>
      <DialogContent>
        <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 24, height: 24, color: 'error.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          크루 {history?.length}명이 매칭을 거절했어요. <br/>
          거절 사유를 확인하고 공고를 수정해주세요.
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }} paragraph>
          공고를 수정하고, 좋은 크루를 놓치지 마세요!
        </Typography>
        <Stack spacing={1} sx={{ pt: 1 }}>
          {history?.map((reject, index) => (
            <Stack
              key={index}
              direction={{ xs: "column", sm: "row" }}
              spacing={0.5}
              sx={{
                display: 'flex', px: 2, py: 1.5,
                backgroundColor: 'rgba(255, 72, 66, 0.08);', borderRadius: 1,
                ...smUp && { justifyContent: 'space-between', alignItems: 'center' }
              }}
            >
              <Typography variant="subtitle2">
                {reject.crew_reject_reason}
              </Typography>
              <Typography variant="caption" sx={{ color: "text.disabled", whiteSpace: "nowrap" }}>
                {fKrDateKST(reject.crew_reject_at)}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        {editJobPost && (
        <Stack direction={{ xs: "column-reverse", sm: "row" }} sx={{ width: 1 }} spacing={2} justifyContent="flex-end">
        <Button
          onClick={closeDialog}
          size="large"
          sx={{ px: 4 }}
        >
          닫기
        </Button>
        <Button
          variant="contained"
          onClick={editJobPost}
          size="large"
          sx={{ px: 4 }}
        >
          공고 수정하기
        </Button>
        </Stack>
        )}
        {!editJobPost && (
          <Button
            variant="contained"
            onClick={closeDialog}
            size="large"
            sx={{ px: 4 }}
          >
            닫기
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
};
